import { render, staticRenderFns } from "./CenterAS.vue?vue&type=template&id=035888f7&scoped=true&"
import script from "./CenterAS.vue?vue&type=script&lang=js&"
export * from "./CenterAS.vue?vue&type=script&lang=js&"
import style0 from "./CenterAS.vue?vue&type=style&index=0&id=035888f7&lang=scss&scoped=true&"
import style1 from "./CenterAS.vue?vue&type=style&index=1&id=035888f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035888f7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VContainer,VDialog,VForm,VLayout,VRadio,VRadioGroup,VRow})
